import CXMApiClient from "../../CXMApiClient";
import Vue from "vue";

function initialState() {
  return {
    ContactOwnedVehicles: [],
    LoadingContactOwnedVehicles: false,
    CD_ActionTypes: []
  };
}

const state = initialState();

const getters = {
  ContactOwnedVehicles() {
    return state.ContactOwnedVehicles;
  },
  CurrentlyOwnedVehicles(state) {
    return state.ContactOwnedVehicles && state.ContactOwnedVehicles.length > 0
      ? state.ContactOwnedVehicles.filter(vehicle => !vehicle.noLongerOwns)
      : [];
  },
  PreviouslyOwnedVehicles(state) {
    return state.ContactOwnedVehicles && state.ContactOwnedVehicles.length > 0
      ? state.ContactOwnedVehicles.filter(vehicle => vehicle.noLongerOwns)
      : [];
  }
};

const actions = {
  async getContactVOIs(context, request) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "GET",
      `/crm/contacts/${request.contactId}/vehicles/vehicles_of_interest`
    );
    return response && response.data.successful ? response.data : null;
  },
  getVehiclesOwnedByContactId(context, request) {
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      let url = "/crm/contacts/" + request.contactId + "/vehicles/owned";
      client
        .ProcessRequest("get", url, null, request.scope ? [request.scope] : [])
        .then(response => {
          if (response.data && response.data.successful) {
            // TODO: Verify with Product and API before returning vehicles without entityId, that are added as trade-in vehicles
            let results = response.data.data || [];
            context.dispatch("updateAllContactOwnedVehicles", results);
            results = results.filter(
              vehicle => vehicle.entityId && vehicle.entityId.trim().length > 0
            );
            resolve(results);
          } else reject(response);
        })
        .catch(function(error) {
          reject(error.response);
        });
    });
  },
  loadContactOwnedVehicles: function(context, request) {
    return new Promise((resolve, reject) => {
      context.commit("toggleLoadingContactOwnedVehicles", true);
      context
        .dispatch("getVehiclesOwnedByContactId", request)
        .then(response => {
          context.commit("toggleLoadingContactOwnedVehicles", false);
          context.commit("updateContactOwnedVehicles", response);
          resolve(response);
        })
        .catch(function(error) {
          context.commit("toggleLoadingContactOwnedVehicles", false);
          reject(error);
        });
    });
  },
  clearContactOwnedVehicles(context) {
    context.commit("clearContactOwnedVehicles");
  },
  loadActivityTypes: function(context) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("pando/pandox/actiontypes")
        .then(response => {
          if (response.data.Success) {
            context.commit("update_CD_ActionTypes", response.data.Data);
            resolve(response);
          } else {
            reject("Failed to retrieve Activity/Action Pairs.");
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

const mutations = {
  updateContactOwnedVehicles: function(state, data) {
    state.ContactOwnedVehicles = data;
  },
  clearContactOwnedVehicles(state) {
    state.ContactOwnedVehicles = [];
  },
  toggleLoadingContactOwnedVehicles(state, value) {
    state.LoadingContactOwnedVehicles = value;
  },
  update_CD_ActionTypes: function(state, data) {
    state.CD_ActionTypes = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/CustomerDashboard.js